import useCar from "@/components/report/useCar";
import parking from "@/components/report/parking";
import stay from "@/components/report/stay";
import driving from "@/components/report/driving";
import daily from "@/components/report/daily";
import reportAssess from "@/components/report/reportAssess";
import personWorkReport from "@/components/report/PersonQualified";
import carWorkReport from "@/components/report/carWorks";
import refuel from "@/components/report/refuel";
import defuel from "@/components/report/defuel";
import richangbaojietongji from "@/components/report/richangbaojie";
import richangxunchatongji from "@/components/report/richangbaojie";
import xiaoxiutongji from "@/components/report/richangbaojie";
import yingjitongji from "@/components/report/richangbaojie";


var data = [
  {
    path: "/refuel",
    component: refuel
  },
  {
    path: "/defuel",
    component: defuel
  },
  {
    path: "/useCar",
    component: useCar
  },
  {
    path: "/stay",
    component: stay
  },
  {
    path: "/parking",
    component: parking
  },
  {
    path: "/reportAssess",
    component: reportAssess
  },
  {
    path: "/richangbaojietongji",
    component: richangbaojietongji
  },
  {
    path: "/richangxunchatongji",
    component: richangxunchatongji
  },
  {
    path: "/xiaoxiutongji",
    component: xiaoxiutongji
  },
  {
    path: "/yingjitongji",
    component: yingjitongji
  },
  {
    path: "/personWorkReport",
    component: personWorkReport
  },
  {
    path: "/carWorkReport",
    component: carWorkReport
  },
  {
    path: "/driving",
    component: driving
  },
  {
    path: "/daily",
    component: daily
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/report.js